// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XQJm","rootMobile":"styles_rootMobile__1WQ7b"};